import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { z } from 'zod';
import { createAuthMutation } from '../auth-http-client';
import { Setting } from '../types';

export type EditGameSettingsMutationParams = {
	gameId: number;
	accountId: number;
	currency: string;
	settings: Setting[];
};

export const createEditGameSettingsMutation = () =>
	createAuthMutation({
		params: declareParams<EditGameSettingsMutationParams>(),
		request: {
			method: 'PATCH',
			url: '/games-settings',
			body: (data) => data,
		},
		response: {
			contract: zodContract(z.null()),
		},
	});
